module.exports = __webpack_public_path__ + "static/media/superhero.3ac0f7c0.ttf";